import { useState } from "react"
import { DialogProps } from "../components/Dialog/Dialog"

type DialogConfig = Omit<DialogProps, "handleClose"> & { cancelText?: string }

export function useDialogConfig() {
  const initialConfig: DialogConfig = {
    description: "",
    isOpen: false,
    title: "",
    variant: "alert",
  }

  const [dialogConfig, setDialogConfig] = useState(initialConfig)

  const handleClose = () => {
    setDialogConfig({ ...dialogConfig, isOpen: false })
  }

  const openDialog = (config: Omit<DialogConfig, "isOpen">) => {
    setDialogConfig({ ...config, isOpen: true })
  }

  return { ...dialogConfig, handleClose, openDialog }
}
